import { language, languageDefault } from "./Language";

export const STEPS = {
    LOGIN: 'LOGIN',
    SCAN_QR: 'SCAN_QR',
    AMOUNT: 'AMOUNT',
    CRYPTO: 'CRYPTO',
    LOADING_DATA: 'LOADING_DATA',
    CREATE_ACCOUNT: 'CREATE_ACCOUNT',
    VALIDATE_CODE: 'VALIDATE_CODE',
    PRE_CONNECT_ACCOUNT: 'PRE_CONNECT_ACCOUNT',
    STATUS_KYC_CRYPTOFACIL: "STATUS_KYC_CRYPTOFACIL"
}

export const STEPS_CRYPTO_PAYMENT = {
    LOADING_DATA: "LOADING_DATA",
    COIN_NETWORK: "COIN_NETWORK",
    DETAILS_PAYMENT: "DETAILS_PAYMENT"
}

export const STATUS_TIMER = {
    STARTED: "Started",
    STOPPED: "Stopped",
};

export const PFW = "PFW";

export const ENV_DEV = "dev";
export const ENV_TEST = "test";
export const ENV_DEMO = "demo";
export const ENV_LIVE = "prod";
export const ENV_PRE_LIVE = "preprod";

export const REGEX_ONLY_NUMBER = /^[0-9]*\.?[0-9]*$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
export const REGEX_ONLY_LETTER = /^[a-zA-Z ]+$/;

export const EMAIL_INFO_PF = "info@paguelofacil.com"
export const DEEP_LINK_QR_RECHARGE_APP = "https://paguelofacil.page.link/clickActionData--APP_RECHARGE_BALANCE"

export const handleTitleReceive = (status, txType) => {
    const isApproved = () => status === 1;
    const isRefunded = () => status === 3;
    const isPartialRefunded = () => status === 2 && txType !== "AUTH";
    const isCaptured = () => status === 2 && txType === "AUTH";
    const isSubscription = () => isApproved() && txType === "RECURRENT";

    if (isSubscription()) return "proof_recurrent";

    if (isApproved()) return "proof_payment";

    if (isRefunded()) return "proof_refunded";

    if (isPartialRefunded()) return "proof_parcial_refunded";

    if (isCaptured()) return "proof_captured";

    return "proof_recharge";
};

export const dictionaryPaymentMethod = {
    keyTranslate: language.method_crypto,
    defaultValueTranslate: languageDefault.method_crypto,
    logoPaymentMethod: "https://assets.paguelofacil.com/checkout/coins.webp",
    widthLogo: "20",

    status: {
        0: {
            label: languageDefault.pending,
            keyTranslate: language.pending,
            color: "#D69E2E",
        },
        1: {
            label: languageDefault.aproved,
            keyTranslate: language.aproved,
            color: "#4CA80B",
        },
        2: {
            label: languageDefault.pending,
            keyTranslate: language.pending,
            color: "#D69E2E",
        },
        3: {
            label: languageDefault.pending,
            keyTranslate: language.pending,
            color: "#D69E2E",
        },
    },
}

//decodificar texto a utf-8
export const utf8_decoder = (str) => {
    if (typeof str === "string" && str.length > 0) {
        return new TextDecoder("utf-8").decode(Uint8Array.from(str, x => x.charCodeAt(0)));
    } else {
        return str;
    }
};